import _cloneDeep from 'lodash.clonedeep';

export function cloneDeep(value: any) {
  return _cloneDeep(value);
}
